import { Filter } from "./Pageable"

import type { UserDto } from "project-simple-server-open-api/client"

export type CalendarEventType = "TIME_OFF"

export class BaseCalendarEventRequestDto {
  type?: CalendarEventType = "TIME_OFF"
  description = ""
  startDate = ""
  endDate = ""
  allDay = true
  userIds: string[] = []

  constructor(props?: Partial<BaseCalendarEventRequestDto>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    return {
      type: this.type,
      description: this.description,
      startDate: this.startDate,
      endDate: this.endDate,
      allDay: this.allDay,
      userIds: this.userIds
    }
  }
}

export class CalendarEventQueryDto extends Filter {
  from = ""
  to = ""
  userIds?: string[] = undefined
  teamIds?: string[] = undefined
  types?: CalendarEventType[] = undefined
  includeDemo?: boolean = undefined

  constructor(props?: Partial<CalendarEventQueryDto>) {
    super(props as Filter)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    const data = {
      from: this.from,
      to: this.to,
      userIds: this.userIds,
      teamIds: this.teamIds,
      types: this.types,
      includeDemo: this.includeDemo
    }

    return super.getJsonObj({ params: data, withoutPagination: true })
  }
}

export class CreateCalendarEventRequestDto extends BaseCalendarEventRequestDto {
  constructor(props?: Partial<CreateCalendarEventRequestDto>) {
    super(props)
  }
}

export class UpdateCalendarEventRequestDto extends BaseCalendarEventRequestDto {
  constructor(props?: Partial<UpdateCalendarEventRequestDto>) {
    super(props)
  }
}

export class CalendarEventDto extends BaseCalendarEventRequestDto {
  id = ""
  accountId = ""
  calendarId = ""
  demo = false
  users: UserDto[] = []
  createdBy?: string
  createdDate?: string
  modifiedBy?: string
  modifiedDate?: string

  constructor(props?: Partial<CalendarEventDto>) {
    super(props)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
    this.users = props.users ?? []
  }
}
